angular.module("tromanWeb").directive("ergoAdvancedSearch", [function () {
    return {
        restrict: "A",
        template: require('./ergoAdvancedSearch.html'),
        scope: {
            title: '@'
        },
        transclude: true,
        link: function (scope, element, attributes) {
            scope.title = scope.title || "Avancerad Sökning";
            scope.isopen = !!scope.$parent.$eval(attributes.ergoAdvancedSearch);
            element.addClass('ergo-advanced-search');
        }
    };
}]);
